// extracted by mini-css-extract-plugin
module.exports = {"dashboardLettersGraduation":"dashboard-letters-graduation_dashboardLettersGraduation__rMy0U","editButton":"dashboard-letters-graduation_editButton__2g1Y5"};